import { Observable, of } from 'rxjs';
import { ComponentPermissionService, PermissionFunction } from '../component-permission.service';

export function canViewAdminTools(service: ComponentPermissionService): PermissionFunction {
  return {
    name: 'Can View Admin Tools',
    description: 'Check if user has permission to view administrative tools and sections',
    requiresContext: false,
    execute: (context?: any) => {
      
      // Get current user
      const currentUser = service.authService.getCurrentUser();
      if (!currentUser) {
        return of(false);
      }

      // Check if user has admin roles
      const adminRoles = ['superadmin', 'orgadmin', 'uddansvarlig', 'uddassistent'];
      if (currentUser.roles && currentUser.roles.some((role: string) => adminRoles.includes(role))) {
        return of(true);
      }

      return of(false);
    }
  };
} 